module.exports = __webpack_public_path__ + "static/img/4-3.b276d9a5.png";